const NOT_FOUND_IN_SEQUENCE = /not found in the active sequence/i;
const NO_ACTIVE_SEQUENCE = /no active sequence/i;
const SEARCHED_ASSET_NAME = /^"([^"]+)"\s+not found in the active sequence/i;

const CLIP_NOT_ON_SEQUENCE = "This asset isn't on the timeline — add it to your sequence and try again.";

/** Keeps toast copy readable in the narrow UXP panel. */
export const truncateToastMessage = (message: string, maxLength = 160): string => {
  const normalized = message.replace(/\s+/g, ' ').trim();

  if (normalized.length <= maxLength) {
    return normalized;
  }

  return `${normalized.slice(0, maxLength - 1)}…`;
};

/** Maps verbose UXP host errors to short, actionable copy. */
export const formatSyncHostError = (hostError: string): string => {
  const normalized = hostError.replace(/\s+/g, ' ').trim();

  if (NOT_FOUND_IN_SEQUENCE.test(normalized)) {
    const searchedName = SEARCHED_ASSET_NAME.exec(normalized)?.[1];

    if (searchedName) {
      return truncateToastMessage(
        `Couldn't find "${searchedName}" on the timeline — add it to your sequence and try again.`,
      );
    }

    return CLIP_NOT_ON_SEQUENCE;
  }

  if (NO_ACTIVE_SEQUENCE.test(normalized)) {
    return 'No active sequence — open a sequence and try again.';
  }

  return truncateToastMessage(normalized);
};

export const formatMarkerSyncError = (hostError: string) => `Marker sync failed — ${formatSyncHostError(hostError)}`;

export const formatChapterSyncError = (hostError: string) => `Chapter sync failed — ${formatSyncHostError(hostError)}`;
